var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvecoHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29448",
    "data-name": "Group 29448",
    transform: "translate(-288 -662.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(288 662.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "IVECO",
    transform: "translate(301 676.997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8465",
    "data-name": "Rectangle 8465",
    width: 1.792,
    height: 5.975,
    rx: 0.5,
    transform: "translate(0 0)",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50579",
    "data-name": "Path 50579",
    d: "M7.269,19H8.361a.286.286,0,0,1,.263.239L9.4,22.528a.268.268,0,0,0,.525,0l.773-3.289A.286.286,0,0,1,10.957,19H11.5a.321.321,0,0,1,.266.4l-.931,4.914a.8.8,0,0,1-.782.657H8.716a.8.8,0,0,1-.782-.657L7,19.406A.321.321,0,0,1,7.269,19Z",
    transform: "translate(-4.009 -19)",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50580",
    "data-name": "Path 50580",
    d: "M21.78,19.332V20a.337.337,0,0,1-.341.332H19.39a.336.336,0,0,0-.341.332v.664h1.707a.337.337,0,0,1,.341.332v.664a.337.337,0,0,1-.341.332H19.049v.664a.336.336,0,0,0,.341.332h2.049a.337.337,0,0,1,.341.332v.664a.337.337,0,0,1-.341.332H17.683A.673.673,0,0,1,17,24.311V19.664A.673.673,0,0,1,17.683,19h3.756A.337.337,0,0,1,21.78,19.332Z",
    transform: "translate(-8.038 -19)",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50581",
    "data-name": "Path 50581",
    d: "M31.439,19h-2.39A2.021,2.021,0,0,0,27,20.991v1.992a2.021,2.021,0,0,0,2.049,1.991h2.39a.337.337,0,0,0,.341-.332v-.664a.337.337,0,0,0-.341-.332H29.731a.673.673,0,0,1-.682-.664V20.991a.673.673,0,0,1,.682-.664h1.708A.337.337,0,0,0,31.78,20v-.664A.337.337,0,0,0,31.439,19Z",
    transform: "translate(-12.063 -19)",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50582",
    "data-name": "Path 50582",
    d: "M40.583,19H39.388A2.533,2.533,0,0,0,37,21.655v.664a2.533,2.533,0,0,0,2.39,2.655h1.195a2.533,2.533,0,0,0,2.39-2.655v-.664A2.533,2.533,0,0,0,40.583,19Zm.6,3.32a1.2,1.2,0,1,1-2.39,0v-.664a1.2,1.2,0,1,1,2.39,0Z",
    transform: "translate(-16.085 -19)",
    fill: "#0b447c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvecoHighlighted);
export default __webpack_public_path__ + "static/media/ivecoHighlighted.56c00b5b7a405a36595947d86fda2199.svg";
export { ForwardRef as ReactComponent };